import PrintReport from "./PrintReport";

export default PrintReport;
